import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { BoxButton, Card, CardContent, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, semanticColor } from '@repo/ui';

interface CheckAccountNameDrawerViewProps {
  onClickYes: () => void;
  accountName: string;
  account: {
    bankId: string;
    accountNumber: string;
  };
  bankName: string;
  bankIconFileName?: string;
  title: string;
}

export const CheckAccountNameDrawerView = NiceModal.create(
  ({ onClickYes, accountName, account, bankName, bankIconFileName, title }: CheckAccountNameDrawerViewProps) => {
    const { visible, hide } = useModal();

    return (
      <Drawer open={visible}>
        <DrawerContent>
          <DrawerHeader className={'heading-small-bold'}>{title}</DrawerHeader>
          <DrawerBody className={'pb-normal-xlarge'}>
            <Card className={'w-full'} outline={false} bg={semanticColor.neutral.background.lowest}>
              <CardContent>
                <div className={'flex gap-tiny-large justify-between items-center'}>
                  <div>
                    <div className={'body-medium-semibold text-neutral-foreground-main'}>{accountName}</div>
                    <div className={'caption-small-regular text-neutral-foreground-low'}>
                      {bankName} {account.accountNumber}
                    </div>
                  </div>
                  <div>
                    <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/external/${bankIconFileName}.svg`} className={'w-9 h-9'} alt={''} />
                  </div>
                </div>
              </CardContent>
            </Card>
          </DrawerBody>
          <DrawerFooter className={'container container-padding-medium container-medium pb-normal-medium'}>
            <div className={'flex gap-normal-small w-full'}>
              {/* TODO: 구DS 걷어낸 후 bg important 삭제 필요 */}
              <BoxButton type={'button'} variant={'tonal-secondary'} size={'large'} className={'w-full !bg-secondary-background-low'} onClick={hide}>
                계좌 수정
              </BoxButton>
              <BoxButton type={'button'} size={'large'} className={'w-full !bg-primary-background-main'} onClick={onClickYes}>
                네, 맞아요
              </BoxButton>
            </div>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    );
  }
);
